const {
  strinct
} = require('../utils/serialize');

class CategoryLocalizationDictionary {
  constructor({
    id,
    locale,
    content,
    isDefault
  }) {
    this.id = id;
    this.locale = locale;
    this.content = content;
    this.isDefault = isDefault === true;
  }

}

CategoryLocalizationDictionary.fromJson = json => new CategoryLocalizationDictionary({
  id: json.id,
  locale: json.locale,
  content: {
    name: json.content.name,
    shortName: json.content.shortName
  },
  isDefault: json.default
});

CategoryLocalizationDictionary.serialize = dictionary => ({
  locale: dictionary.locale,
  content: {
    name: strinct(dictionary.content.name),
    shortName: strinct(dictionary.content.shortName)
  },
  default: dictionary.isDefault === true
});

module.exports = CategoryLocalizationDictionary;